import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import CpfCnpjInput from '../../components/Inputs/CpfCnpjInput';
import SelectInput from '../../components/Inputs/SelectInput';
import { objectsConstants } from '../../constants/objects.constants';
import { formatterHelper } from '../../helpers/formatter.helper';
import { clienteService } from '../../services/cliente.service';
import { defaultService } from '../../services/defaultService';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import FormInput from '../../components/Inputs/FormInput';
class ClienteEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    this.state = { entity: {} };
  }

  componentDidMount() {
    console.log('componentDidMount Cliente Edit');

    if (this.props.match.params.id) {
      clienteService.doGet(this.props.match.params.id).then(
        (response) => {
          console.log(response);
          let cliente = response.data;
          console.log(cliente);
          cliente.senha = null;
          this.setState({ entity: cliente }, () => {});
        },
        (error) => {
          console.log('error');
          console.log(error);
          this.props.loading(false);
        }
      );
    }
  }

  clearError = () => {
    this.props.clear();
    return '';
  };

  render() {
    const { entity } = this.state;
    let id;
    if (_.get(entity, '_links.self.href')) {
      id = defaultService.getIdFromUrl(_.get(entity, '_links.self.href'));
    }

    const isEdit = !!id;
    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle="Cliente" subTitle=" " canBack={true} />
        <Formik
          validationSchema={{}}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            let clientEntity = values;
            console.log(clientEntity);
            if (_.get(clientEntity, '_links.self.href')) {
              _.set(
                clientEntity,
                'id',
                defaultService.getIdFromUrl(
                  _.get(clientEntity, '_links.self.href')
                )
              );
            }
            _.set(clientEntity, 'authorities', null);
            clienteService
              .doSave(clientEntity)
              .then((response) => {
                console.log(response);
                const id = response.data.id;
                values.id = id;
                this.props.history.push('/cliente');
                actions.setSubmitting(false);
                this.clearError();
                this.props.success({ message: 'Cliente salvo com sucesso.' });
              })
              .catch((e) => {
                actions.setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} noValidate>
              <div className="flex-column">
                {!_.isEmpty(errors) &&
                  this.showError(objectsConstants.messageCampoObrigatorio)}

                {values.id && this.clearError()}
                <div className="cardSeculus d-flex flex-column mb-0">
                  <div className="topoCard d-flex flex-column flex-sm-row">
                    <h3 className="flex-grow-1">Cliente</h3>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-12 col-md-6">
                      <label>Nome Fantasia*</label>
                      <input
                        type="text"
                        className={`form-control ${errors.nomeFantasia &&
                          touched.nomeFantasia &&
                          'error'}`}
                        name="nomeFantasia"
                        placeholder="Digite o nome fantásia"
                        value={values.nomeFantasia}
                        disabled
                        onChange={(e) => {
                          const { name, value } = e.currentTarget;
                          if (value) {
                            setFieldValue(name, value.toProperCase());
                          } else {
                            setFieldValue(name, value);
                          }
                        }}
                      />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <label>Razão Social*</label>
                      <input
                        type="text"
                        className={`form-control ${errors.razaoSocial &&
                          touched.razaoSocial &&
                          'error'}`}
                        name="razaoSocial"
                        placeholder="Digite a razão social"
                        value={values.razaoSocial}
                        onChange={(e) => {
                          const { name, value } = e.currentTarget;
                          if (value) {
                            setFieldValue(name, value.toProperCase());
                          } else {
                            setFieldValue(name, value);
                          }
                        }}
                      />
                    </div>

                    <div className="form-group col-12 col-md-6">
                      <CpfCnpjInput
                        placeholder="Digite o CNPJ ou CPF"
                        erroMensagem={errors.cnpjCpf}
                        id={'cnpjCpf'}
                        name="cnpjCpf"
                        value={values.cnpjCpf}
                        onChange={handleChange}
                        noSize={true}
                        label={'CNPJ ou CPF'}
                      />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <SelectInput
                        id={'possuiPontoAtendimento'}
                        options={[
                          { label: 'Sim', value: true },
                          { label: 'Não', value: false },
                        ]}
                        noSize
                        returnFullObject={true}
                        label="Este cliente poderá cadastrar Ponto de Atendimento? "
                        required={true}
                        labelKey={'label'}
                        valueKey={'value'}
                        name={'possuiPontoAtendimento'}
                        defaultValue={
                          values.possuiPontoAtendimento &&
                          values.possuiPontoAtendimento.value === false
                            ? 'Não'
                            : formatterHelper.getLabelEnum(
                                values.possuiPontoAtendimento &&
                                  values.possuiPontoAtendimento.value
                                  ? values.possuiPontoAtendimento.value
                                  : values.possuiPontoAtendimento
                                  ? values.possuiPontoAtendimento
                                  : false,
                                objectsConstants.SIM_NAO
                              )
                        }
                        value={
                          _.isBoolean(values.possuiPontoAtendimento)
                            ? formatterHelper.getEnum(
                                values.possuiPontoAtendimento,
                                objectsConstants.SIM_NAO
                              )
                            : values.possuiPontoAtendimento
                        }
                        onChange={(name, value) => {
                          setFieldValue(name, value.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <SelectInput
                        id={'ocultarLoteValidadeProduto'}
                        options={[
                          { label: 'Sim', value: true },
                          { label: 'Não', value: false },
                        ]}
                        noSize
                        returnFullObject={true}
                        label="Ocultar lote e validade dos produtos para esse cliente? "
                        required={true}
                        labelKey={'label'}
                        valueKey={'value'}
                        name={'ocultarLoteValidadeProduto'}
                        defaultValue={
                          values.ocultarLoteValidadeProduto &&
                          values.ocultarLoteValidadeProduto.value === false
                            ? 'Não'
                            : formatterHelper.getLabelEnum(
                                values.ocultarLoteValidadeProduto &&
                                  values.ocultarLoteValidadeProduto.value
                                  ? values.ocultarLoteValidadeProduto.value
                                  : values.ocultarLoteValidadeProduto
                                  ? values.ocultarLoteValidadeProduto
                                  : false,
                                objectsConstants.SIM_NAO
                              )
                        }
                        value={
                          _.isBoolean(values.ocultarLoteValidadeProduto)
                            ? formatterHelper.getEnum(
                                values.ocultarLoteValidadeProduto,
                                objectsConstants.SIM_NAO
                              )
                            : values.ocultarLoteValidadeProduto
                        }
                        onChange={(name, value) => {
                          setFieldValue(name, value.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-12">
                      <h4>Endereço</h4>
                    </div>

                    {[
                      'logradouro',
                      'numero',
                      'complemento',
                      'bairro',
                      'cidade',
                      'uf',
                      'cep',
                    ].map((field) => {
                      return (
                        <div className="form-group col-12 col-lg-6" key={field}>
                          {field === 'uf' ? (
                            <SelectInput
                              id={`endereco.${field}`}
                              label="UF"
                              noSize
                              required={false}
                              returnFullObject={true}
                              labelKey="label"
                              valueKey="value"
                              name={`endereco.${field}`}
                              options={objectsConstants.UF}
                              value={
                                _.isObject(_.get(values, `endereco.${field}`))
                                  ? _.get(values, `endereco.${field}`)
                                  : {
                                      label: _.get(values, `endereco.${field}`),
                                      value: _.get(values, `endereco.${field}`),
                                    }
                              }
                              onChange={(name, value) =>
                                setFieldValue(name, value ? value.value : '')
                              }
                            />
                          ) : (
                            <FormInput
                              label={_.startCase(field)}
                              noSize
                              id={`endereco${field}`}
                              type="text"
                              required={false}
                              erroMensagem={_.get(errors, `endereco.${field}`)}
                              name={`endereco.${field}`}
                              value={_.get(values, `endereco.${field}`, '')}
                              onChange={setFieldValue}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <div className="d-flex flex-row flex-sm-row ">
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="button"
                        className="btn btn-secondary btn30 white"
                        disabled={isSubmitting}
                        onClick={() => this.props.history.goBack()}
                      >
                        Cancelar
                      </button>
                    </div>
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="submit"
                        className="btn btn-secondary btn30 green"
                        disabled={isSubmitting}
                      >
                        {isEdit ? 'Salvar Alterações' : 'Salvar'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;

  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  {
    forwardRef: true,
  }
)(ClienteEdit);
